<template>
  <div id="BottomButtonGroup">
    <div class="main-warp">
      <div class="button-group">
        <el-button class="button" @click="submitFail">{{ $t("reserve.status.Fail") }}</el-button>
        <el-button class="button-primary" type="primary" @click="submitPass">{{ $t("reserve.status.Pass") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApprovalButtonGroup",
  data() {
    return {}
  },
  methods: {
    submitFail() {
      this.$emit("submitFail")
    },
    submitPass() {
      this.$emit("submitPass")
    },
  },
}
</script>

<style scoped></style>
